import { requests } from '../../../generated/client/proto-generated';

export type Type = requests.com.wixpress.wixdocs.IType;
export type ComplexType = requests.com.wixpress.wixdocs.IComplexType;
export type TypeParameter = requests.com.wixpress.wixdocs.TypeParameter;

export type TypeInServiceJson = Type[] | LegacyType;

export interface LegacyComplexType {
  name: string;
  typeParams: LegacySingleType[];
}

export type LegacySingleType = LegacyComplexType | string;

export type LegacyType = LegacySingleType | LegacySingleType[];

export const isLegacyComplexType = (
  obj: LegacyType,
): obj is LegacyComplexType => {
  return (
    typeof obj !== 'string' &&
    !Array.isArray(obj) &&
    obj.name !== undefined &&
    obj.typeParams !== undefined
  );
};

export const isLegacyType = (type): type is LegacyType => {
  if (!Array.isArray(type)) {
    return typeof type === 'string' || isLegacyComplexType(type);
  }
  return type.some(
    (_type) => typeof _type === 'string' || isLegacyComplexType(_type),
  );
};

export const extractTypeInProtoFormat = (
  type: Type | TypeParameter,
): string | TypeParameter[] | Type[] => {
  if (type.nativeType || type.referenceType) {
    return type.nativeType || type.referenceType;
  }
  if (type.complexType) {
    return type.complexType.typeParams;
  }
  const typeAsTypeParameter = type as TypeParameter;
  if (typeAsTypeParameter.unionType) {
    return typeAsTypeParameter.unionType.type;
  }
};

export const extractFirstLevelOfTypeObject = (
  type: Type,
): string | ComplexType => {
  if (type.nativeType || type.referenceType) {
    return type.nativeType || type.referenceType;
  }
  return type.complexType;
};
